import { useEffect, type ReactNode } from 'react';

type Props = {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  size?: 'md' | 'full';
};

export function Modal({ open, onClose, title, children, size = 'md' }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  if (size === 'full') {
    return (
      <div className="fixed inset-0 z-50 bg-bg p-6" role="dialog" aria-modal>
        {children}
      </div>
    );
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-6"
      role="dialog"
      aria-modal
    >
      <div className="absolute inset-0 bg-black/45" onClick={onClose} aria-hidden />
      <div className="relative w-full max-w-[400px] rounded-xl bg-surface p-6 shadow-none border-hairline border-border">
        {title ? <h2 className="mb-3 text-[18px] font-medium text-ink">{title}</h2> : null}
        <div className="text-[14px] text-ink">{children}</div>
      </div>
    </div>
  );
}
